/* eslint camelcase: 0 */
// we get these prop names from a rails API, so stop whining about camel case.

import React from 'react'
import smartDate from '@qrohlf/smart-date'
import { SelectableList, ListItem } from 'common/SelectableList'

import styles from './RidePicker.scss'

export const RideList = ({ rides, selected, onRideClick }) => {
  const itemize = ride => (
    <ListItem key={ride.id} selected={selected.get(ride.id)} onClick={() => onRideClick(ride)}>
      <Ride {...ride} />
    </ListItem>
  )

  return (
    <div className={styles.RideList}>
      <SelectableList>
        {rides.map(itemize)}
      </SelectableList>
    </div>
  )
}

const Ride = ({ onClick, name, departed_at, selected, short_location }) => {
  const date = smartDate(departed_at, { includeTime: false })
  return (
    <div onClick={onClick} className={styles.Ride}>
      <h2 title={name} className={styles.singleLine}>{name}</h2>
      <span title={short_location} className={styles.singleLine}>{short_location}</span>
      <span title={date} className={styles.singleLine}>{date}</span>
    </div>
  )
}
